import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";
import { ProgressBar } from "$/game/prefabs/ui/ProgressBar.ts";
import { RoundedTextButton } from "$/game/prefabs/ui/RoundedTextButton.ts";
import { audiosprites, musicPaths } from "$/keys";

export class LoadingScene extends BasicScene {
  private progressBar!: ProgressBar;
  private container!: Phaser.GameObjects.Container;
  private width!: number;
  private height!: number;

  constructor() {
    super("LoadingScene");
  }

  override preload() {
    super.preload();

    this.width = this.cameras.main.width;
    this.height = this.cameras.main.height;

    this.progressBar = new ProgressBar(
      this,
      -this.width / 4,
      230,
      this.width / 2,
      30,
    );
    this.load.on(
      "progress",
      (value: number) => this.progressBar.updateProgress(value),
    );

    this.container = this.add.container(this.width / 2, this.height / 2);
    // Atlas already loaded in PreloadScene, use atlas + frame
    const banner = this.add.image(
      0,
      -120,
      this.atlas,
      this.keys.assets.sprites.banner,
    )
      .setOrigin(0.5, 0.5);
    this.container.add(banner);
    this.container.add(this.progressBar);

    this.tweens.add({
      targets: banner,
      angle: { from: -3, to: 3 },
      duration: 2000,
      ease: "Sine.inOut",
      yoyo: true,
      repeat: -1,
    });

    // Load audiosprite audio and JSON data separately
    this.load.audio(audiosprites.sfx.key, audiosprites.sfx.audio);
    this.load.json(`${audiosprites.sfx.key}-data`, audiosprites.sfx.data);

    // Load music files (non-blocking)
    for (const [key, path] of Object.entries(musicPaths)) {
      this.load.audio(key, path);
    }

    this.load.on("complete", () => {
      // Initialize SoundManager after audio is loaded
      this.soundManager.init();
      
      // Start background music immediately
      this.soundManager.playMusic(this.keys.assets.sounds.music.home);
    });
  }

  create() {
    // Scene is now empty - auto-redirect after a small delay to ensure transition system is ready
    this.input.enabled = true;
    this.progressBar.destroy();
    
    // Add a small delay to ensure transition system is fully initialized
    this.time.delayedCall(100, () => {
      const pet = this.storage.pet();
      if (pet == null) {
        this.transition.toScene(
          "PetCreateScene",
          this.keys.strings.sceneTransitions.createPet,
        );
      } else {
        if (pet.is_alive) {
          this.transition.toScene(
            "PetHomeScene",
            this.keys.strings.sceneTransitions.welcomeBack,
          );
        } else {
          this.transition.toScene(
            "PetDeathScene",
            this.keys.strings.sceneTransitions.petIsDead,
          );
        }
      }
    });
  }
}
